import React from 'react';
import ReactDOM from "react-dom";
import Main from "./Main";
import "@babel/polyfill";


ReactDOM.render(
  <Main />,
  document.getElementById("root")
);